import React, {Component} from 'react';
import BITE from '../../Images/biteicon.png'
import './FirstAid.css'

class Bites extends Component {
    render() {
        return(
            <div className="firstaid-content">
                <h2>Bites</h2>
                <h3>Bites from other Dogs</h3>
                <img src={BITE} className="BITE" alt='dogbiteicon'/>
                <p>All bites should be evaluated by a veterinarian. Mouths are full of bacteria, and infections can be serious.
                Some bites may have crush damage (dog jaws are pretty strong!), even if there isn't a large puncture wound.
                </p>
                <p>If possible, it is also important to find out a little about the biter's health history. Some pretty serious diseases can
                     be spread by bites, and can potentially really harm your dog or you. Making sure the other dog is currently vaccinated is important.
                </p>
                <h3>Bites from Snakes</h3>
                <p>Snake bites can be pretty frightening, and aren't uncommon with dogs. Fido might be curious on a trail hike, and the next thing you know he has a bite right on his nose.
                </p>
                <p>If you suspect your dog has been bitten by a snake, it is important to see a veterinarian. Even if the snake is not venemous, snake bites can be deep and can cause a bacterial infection. If the snake is venemous, your dog made need help very quickly. Swelling, seuizures, coma, fever, and disorientation can be signs of a venemous bite. Get to a vet quickly! If possible, try to identify what type of snake bit your dog, but don't get bitten yourself!</p>
                <p>You can do your dog a big favor by learning about the snakes native to your region. Keep an eye on dogs when hiking or in areas snakes are common. Treating snake bites is easier when the vet knows what kind of snake bit your dog.</p>
            </div>
        )
    }
}

export default  Bites